export const contentTableConfig = {
  title: '访问记录',
  propList: [
    {
      prop: 'title',
      label: '标题',
      minWidth: '120',
      slotName: 'title'
    },
    { prop: 'pv', label: '访问次数(pv)', sortable: true, minWidth: '80' },
    {
      prop: 'uv',
      label: '客户数量(uv)',
      sortable: true,
      minWidth: '80'
    },
    {
      prop: 'ip',
      label: 'ip数量',
      sortable: true,
      minWidth: '80'
    },
    {
      prop: 'duration',
      label: '访问时长(min)',
      sortable: true,
      minWidth: '120',
      slotName: 'duration'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
